// extracted by mini-css-extract-plugin
module.exports = {"tableLabel":"e_Kr","container":"e_Lr","hidden":"e_Mr"};